import React, { useEffect, useState } from 'react';
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10, TablesWidget5 } from "../../../smallnation/partials/widgets"

import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";

import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
import { useNavigate, useLocation, useHistory } from 'react-router-dom';
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
import UsNumberValidate from "../../modules/utility/usNumberValidate"


const CreateSchool: FC = () => {
  const intl = useIntl();
  let history = useHistory();
  const [stateData, setStateData] = useState([]);
  const [fileName, setFileName] = useState([]);
  const [fileExtension, setFileExtension] = useState([]);
  const [fileBase64, setFileBase64] = useState([]);
  const [schoolProfileInfo, setSchoolProfile] = useState([]);
  const red = "red";

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function handleChangeSchoolProfileDesc(content) {
    setSchoolProfile(content);
  }
  function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }
  function validateCheck() {
    //alert("test");
  }
  function getImage() {
    var files = document.getElementById('school_logo').files;
    console.log(files);
    if (files.length > 0) {

      var fname = files[0].name;
      // var fextn = fname.substr(0, fname.lastIndexOf('.'));
      var fextn = fname.split(".").pop();
      // alert(fextn);
      var fileActName = fname.split(".")[0];
      // alert(fileActName);
      setFileName(fileActName);
      setFileExtension(fextn);
      getBase64(files[0]);

      if (fextn != "jpg" && fextn != "jpeg" && fextn != "png") {

        $("#fileError").show();
        return false;
      } else {
        $("#fileError").hide();
      }

    }
  }
  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      // console.log(reader.result);
      var base64result = reader.result.split(',')[1];
      setFileBase64(base64result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  const submitValue = () => {
    var email_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    var validateEditorTxt = 1;

    if ($('#school_name').val() == "") {
      $("#schoolValidMsg").show();
      $(window).scrollTop($('#schoolValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#schoolValidMsg").hide();
    }

    if ($('#address_line1').val() == "") {
      $("#addressValidMsg").show();
      $(window).scrollTop($('#addressValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#addressValidMsg").hide();
    }

    if ($('#school_city').val() == "") {
      $("#cityValidMsg").show();
      $(window).scrollTop($('#cityValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#cityValidMsg").hide();
    }

    if ($('#school_state').val() == "") {
      $("#stateValidMsg").show();
      $(window).scrollTop($('#stateValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#stateValidMsg").hide();
    }

    if ($('#postalcode').val() == "") {
      $("#zipValidMsg").show();
      $(window).scrollTop($('#zipValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#zipValidMsg").hide();
    }

    if ($('#postalcode').val() == "") {
      $("#zipValidMsg").show();
      $(window).scrollTop($('#zipValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#zipValidMsg").hide();
    }

    if ($('#school_type').val() == "") {
      $("#schooltypeValidMsg").show();
      $(window).scrollTop($('#schooltypeValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#schooltypeValidMsg").hide();
    }

    if ($('#phone_number').val() == "") {
      $("#phoneValidMsg").show();
      $(window).scrollTop($('#phoneValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#phoneValidMsg").hide();
    }
    var email = $('#email_id').val();
    if (email == "") {
      $("#emailReqMsg").show();
      $(window).scrollTop($('#emailReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#emailReqMsg").hide();
    }

    if (email != "" && email_regex.test(email) == false) {
      $("#emailValidMsg").show();
      $(window).scrollTop($('#emailValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#emailValidMsg").hide();
    }

    if (schoolProfileInfo == "") {
      $("#schoolProfileValidMsg").show();
      $(window).scrollTop($('#schoolProfileValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#schoolProfileValidMsg").hide();
    }

    if (fileExtension == "") {
      //document.getElementById('logo').reset();
      $("#fileReqMsg").show();
      $(window).scrollTop($('#fileReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#fileReqMsg").hide();
    }

    if ((fileExtension != "") && (fileExtension != "jpg" && fileExtension != "jpeg" && fileExtension != "png")) {
      //document.getElementById('logo').reset();
      $("#fileError").show();
      $(window).scrollTop($('#fileError').position().top);
      validateEditorTxt = 0;
    } else {
      $("#fileError").hide();
    }

    if (validateEditorTxt == 0) {
      return false;
    }

    var phone_val = $("#phone_number").val();
    const requestObject = {
      "siteId": 2,
      "name": $('#school_name').val(),
      "schoolTypeId": $('#school_type').val(),
      "content": schoolProfileInfo,
      "address": $('#address_line1').val(),
      "address_1": $('#address_line2').val(),
      "city": $("#school_city").val(),
      "state": $("#school_state").val(),
      "zip": $('#postalcode').val(),
      "email": $('#email_id').val(),
      "phone": phone_val,
      "logoName": fileName,
      "logoExtension": fileExtension,
      "logoByteString": fileBase64,
      //"school_type":$('#school_type').val(),
    }
    console.log(requestObject);
    //return false;
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };
    services.adminAddSchool(requestOptions).then((res) => {
      console.log(res);
      if (res.code == '200') {
        $("#addschoolsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addschoolsuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/schoollist');
        }, 1000);

      }
      else {
        $("#addschoolfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addschoolfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);

      }
    });
  }
  useEffect(() => {
    validateCheck();
    // $('#phone_number').usPhoneFormat();
    ($('#phone_number')).usPhoneFormat();
    $(".se-dialog-tabs").hide();
    $("#schoolProfileValidMsg").hide();

    $("#schoolValidMsg").hide();

    $("#addressValidMsg").hide();
    $("#cityValidMsg").hide();
    $("#stateValidMsg").hide();
    $("#zipValidMsg").hide();
    $("#schooltypeValidMsg").hide();
    $("#phoneValidMsg").hide();
    $("#emailValidMsg").hide();
    $("#emailReqMsg").hide();
    $("#fileReqMsg").hide();
    $("#addschoolsuccessMessage").hide();
    $('#addschoolfailMessage').hide();
    var statesJson = [{ "stateId": 4, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 5, "stateName": "Alaska", "stateCode": "AK" }, { "stateId": 6, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 7, "stateName": "Arizona", "stateCode": "AZ" }, { "stateId": 8, "stateName": "Arkansas", "stateCode": "AR" }, { "stateId": 9, "stateName": "California", "stateCode": "CA" }, { "stateId": 10, "stateName": "Colorado", "stateCode": "CO" }, { "stateId": 11, "stateName": "Connecticut", "stateCode": "CT" }, { "stateId": 12, "stateName": "Delaware", "stateCode": "DE" }, { "stateId": 13, "stateName": "District of Columbia", "stateCode": "DC" }, { "stateId": 14, "stateName": "Florida", "stateCode": "FL" }, { "stateId": 15, "stateName": "Georgia", "stateCode": "GA" }, { "stateId": 16, "stateName": "Hawaii", "stateCode": "HI" }, { "stateId": 17, "stateName": "Idaho", "stateCode": "ID" }, { "stateId": 18, "stateName": "Illinois", "stateCode": "IL" }, { "stateId": 19, "stateName": "Indiana", "stateCode": "IN" }, { "stateId": 20, "stateName": "Iowa", "stateCode": "IA" }, { "stateId": 21, "stateName": "Kansas", "stateCode": "KS" }, { "stateId": 22, "stateName": "Kentucky", "stateCode": "KY" }, { "stateId": 23, "stateName": "Louisiana", "stateCode": "LA" }, { "stateId": 24, "stateName": "Maine", "stateCode": "ME" }, { "stateId": 25, "stateName": "Maryland", "stateCode": "MD" }, { "stateId": 26, "stateName": "Massachusetts", "stateCode": "MA" }, { "stateId": 27, "stateName": "Michigan", "stateCode": "MI" }, { "stateId": 28, "stateName": "Minnesota", "stateCode": "MN" }, { "stateId": 29, "stateName": "Mississippi", "stateCode": "MS" }, { "stateId": 30, "stateName": "Missouri", "stateCode": "MO" }, { "stateId": 31, "stateName": "Montana", "stateCode": "MT" }, { "stateId": 32, "stateName": "Nebraska", "stateCode": "NE" }, { "stateId": 33, "stateName": "Nevada", "stateCode": "NV" }, { "stateId": 34, "stateName": "New Hampshire", "stateCode": "NH" }, { "stateId": 35, "stateName": "New Jersey", "stateCode": "NJ" }, { "stateId": 36, "stateName": "New Mexico", "stateCode": "NM" }, { "stateId": 37, "stateName": "New York", "stateCode": "NY" }, { "stateId": 38, "stateName": "North Carolina", "stateCode": "NC" }, { "stateId": 39, "stateName": "North Dakota", "stateCode": "ND" }, { "stateId": 40, "stateName": "Ohio", "stateCode": "OH" }, { "stateId": 41, "stateName": "Oklahoma", "stateCode": "OK" }, { "stateId": 42, "stateName": "Oregon", "stateCode": "OR" }, { "stateId": 43, "stateName": "Pennsylvania", "stateCode": "PA" }, { "stateId": 44, "stateName": "Puerto Rico", "stateCode": "PR" }, { "stateId": 45, "stateName": "Rhode Island", "stateCode": "RI" }, { "stateId": 46, "stateName": "South Carolina", "stateCode": "SC" }, { "stateId": 47, "stateName": "South Dakota", "stateCode": "SD" }, { "stateId": 48, "stateName": "Tennessee", "stateCode": "TN" }, { "stateId": 49, "stateName": "Texas", "stateCode": "TX" }, { "stateId": 50, "stateName": "Utah", "stateCode": "UT" }, { "stateId": 51, "stateName": "Vermont", "stateCode": "VT" }, { "stateId": 52, "stateName": "Virginia", "stateCode": "VA" }, { "stateId": 53, "stateName": "Washington", "stateCode": "WA" }, { "stateId": 54, "stateName": "West Virginia", "stateCode": "WV" }, { "stateId": 55, "stateName": "Wisconsin", "stateCode": "WI" }, { "stateId": 56, "stateName": "Wyoming", "stateCode": "WY" }];
    setStateData(statesJson);
    $("#fileError").hide();
  }, []);


  return (
    <>
      <PageTitle breadcrumbs={[]}>Add School</PageTitle>

      <form onSubmit={handleSubmit(submitValue)}>

        {/* <h1>write your code here</h1> */}

        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">School Name </label>

                </div>
                <input id="school_name" name="school_name" type="text" className="form-control" placeholder="" />
                <div id="schoolValidMsg" style={{ color: red }} className="error">School Name is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Address </label>

                </div>
                <input type="text" id="address_line1" name="address_line1" className="form-control" placeholder="" />
                <div id="addressValidMsg" style={{ color: red }} className="error">Address is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Address 2</label>

                </div>
                <input type="text" id="address_line2" name="address_line2" className="form-control" placeholder="" />

              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" class="required form-label">City</label>

                </div>
                <input type="text" id="school_city" name="school_city" className="form-control" placeholder="" />
                <div id="cityValidMsg" style={{ color: red }} className="error">City is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" class="required form-label">State</label>

                </div>
                <select className="form-select" id="school_state" name="school_state" aria-label="Select example" >
                  <option selected value="" >Select State</option>
                  {
                    stateData.map((state, index) => (
                      <option value={state.stateName}>{state.stateName}</option>
                    ))
                  }
                </select>
                <div id="stateValidMsg" style={{ color: red }} className="error">State is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" class="required form-label">Zipcode</label>

                </div>
                <input type="text" id="postalcode" name="postalcode" className="form-control" placeholder="" />
                <div id="zipValidMsg" style={{ color: red }} className="error">Zipcode is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" class="required form-label">School Type</label>

                </div>
                <select className="form-select" id="school_type" name="school_type" aria-label="Select example" >
                  <option selected value=''>Select School Type</option>
                  <option value="1">College/University</option>
                  <option value="2">Higher Education</option>
                  <option value="3">School District</option>
                  <option value="4">Trade School</option>
                  <option value="5">Vocational</option>
                </select>
                <div id="schooltypeValidMsg" style={{ color: red }} className="error">School Type is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Phone</label>
                  <small className="mb-3">xxx-xxx-xxxx </small>
                </div>
                <input type="text" id="phone_number" name="phone_number" className="form-control" />
                <div id="phoneValidMsg" style={{ color: red }} className="error">Phone Number is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Email</label>
                  <small className="mb-3">Must be valid for notification</small>
                </div>
                <input type="text" id="email_id" name="email_id" className="form-control" placeholder="" />
                <div id="emailReqMsg" style={{ color: red }} className="error">Email Address is required.</div>

                <div id="emailValidMsg" style={{ color: red }} className="error">Invalid email address.</div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" class="required form-label">School Profile</label>

                </div>
                {/*}<h1>this is FCK editor area</h1>*/}
                {/* <CKEditor
                            editor={ ClassicEditor }
                            config={{
                              removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                            }}
                            id="schoolProfileId"                            
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setSchoolProfile(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeSchoolProfileDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />


                <div id="schoolProfileValidMsg" style={{ color: red }} className="error">School Profile is required.</div>

                {/*<textarea class="form-control textarea" placeholder="School Profile" id="school_profile" name="school_profile" spellcheck="false" {...register("schoolProfile", {
                          required: "School Profile is required",
                          maxLength: { value: 5000, message: 'Should not allow more than 5000 characters' }
                        })}></textarea>
                        <ErrorMessage
                          errors={errors}
                          name="schoolProfile"
                          class="invalid-feedback"
                          render={({ messages }) => {
                            console.log("messages", messages);
                            return messages
                              ? Object.entries(messages).map(([type, message]) => (
                                <p key={type} class="error">{message}</p>
                              ))
                              : null;
                          }}

                        /> */}
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">School Logo</label>
                  <small className="mb-3">JPG, JPEG or PNG, 500px X 500px, .5 MB max size</small>
                </div>
                <input class="form-control form-control-lg browse mr-2" id="school_logo" type="file" onChange={() => getImage()} />
                {/* <input type="file" id="school_logo" name="school_logo" className="form-control" onChange={()=>setschoollogo()} {...register("schoolLogo", {
                          required: "school Logo is required."
                        })}/> */}
                <div id="fileReqMsg" style={{ color: red }} className="error">School Logo is required.</div>

                <div id="fileError" style={{ color: red }} className="error">Invalid file format</div>
              </div>
            </div>



            <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "135px" }}> Register </button>

          </div>
          <div id="addschoolsuccessMessage" class="alert alert-success" role="alert">School Registered Successfully</div>
          <div id="addschoolfailMessage" class="alert alert-danger" role="alert">Please try again</div>

        </div>

      </form>


    </>
  )
}
export { CreateSchool }